import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=66d287c5&scoped=true"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=66d287c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.97.1__ejs@3.1.10_loda_q55i5s7j7wgs6y37ood7fho77a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d287c5",
  null
  
)

export default component.exports